export enum ContractorInputName {
  ContractorName = 'contractor_name',
  SalespersonName = 'salesperson_name',
  AgreeToCheckbox = 'agree_to_checkbox',
  ContractorAutofillUsed = 'contractor_autofill_used',
}
